import React from 'react';
import HeaderSearchRefreshFilterOptions from '../../shared/components/HeaderSearchRefreshFilterOptions';
import Card from '../../shared/components/Card';
import CardHeader from '../../shared/components/card-header/CardHeader';
import CardBody from '../../shared/components/CardBody';
import { I18nUtils } from '../../../i18n/I18nUtils';
import * as workImportActions from '../actions/workImportActions';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import WorkImportTable from './WorkImportTable';

class ImportWorksCard extends React.Component {

    constructor(props) {
        super(props);

        this.onSearch = this.onSearch.bind(this);

        this.state = { search: '' };
    }

    componentWillMount() {
        this.getWorksToImport();
    }

    getWorksToImport() {
        this.props.workImportActions.getWorksToImport(this.state.search);
    }

    onSearch(search) {
        this.setState({ search: search });
    }

    componentDidUpdate(prevProps, prevState) {
        if ( prevState.search !== this.state.search ) {
            this.getWorksToImport();
        }
    }

    renderHeaderOptions() {
        return (
            <HeaderSearchRefreshFilterOptions
                onSearch={this.onSearch}
                enableFilter={false}
                enableRefresh={false}
            />
        );
    }

    render() {
        return (
            <Card loading={this.props.worksImportLoading}>
                <CardHeader title={I18nUtils.tr('TR_IMPORTAR').toUpperCase()}
                            rightOptions={this.renderHeaderOptions()} />
                <CardBody className={'table-responsive'}>
                    <WorkImportTable data={this.props.worksImport} error={this.props.worksImportError} />
                </CardBody>
            </Card>
        );
    }

}

const mapStateToProps = state => {
    let errorMessage = state.worksImport.worksImportError;
    if ( !errorMessage && state.worksImport.worksImport.length === 0 && !state.worksImport.worksImportLoading ) {
        errorMessage = I18nUtils.tr('TR_NO_EXISTEN_RESULTADOS');
    }

    return ( {
        worksImport: state.worksImport.worksImport,
        worksImportLoading: state.worksImport.worksImportLoading,
        worksImportError: errorMessage,
    } );
};

const mapDispatchToProps = dispatch => ( {
    workImportActions: bindActionCreators(workImportActions, dispatch),
} );

export default connect(mapStateToProps, mapDispatchToProps)(ImportWorksCard);



// WEBPACK FOOTER //
// ./src/app/works/components/ImportWorksCard.jsx